import { Icon } from './Icon';

export function ReaderControls({ settings, setSettings, audio }) {
  const playingWholeSurah = Boolean(audio.activeAyah) && audio.queueProgress.label.startsWith('Soera ');
  return (
    <div className="reader-controls" aria-label="Audio-instellingen">
      <div className="reader-primary-controls">
        <button className="button button-primary" type="button" onClick={playingWholeSurah ? audio.togglePause : audio.playSurah}>
          <Icon name={playingWholeSurah && audio.isPlaying ? 'pause' : 'play'} />
          {playingWholeSurah ? (audio.isPlaying ? 'Pauzeer' : 'Ga verder') : 'Speel hele soera'}
        </button>
        {audio.activeAyah && (
          <button className="icon-button stop-button" type="button" onClick={audio.stop} aria-label="Audio stoppen"><Icon name="stop" /></button>
        )}
      </div>

      <label className="select-label">
        <span>Recitator</span>
        <select value={settings.reciter} onChange={(event) => setSettings((current) => ({ ...current, reciter: event.target.value }))}>
          <option value="alafasy">Mishary Alafasy</option>
          <option value="husary">Husary Muallim · langzaam</option>
        </select>
      </label>

      {audio.queueProgress.total > 1 && (
        <div className="audio-progress" role="status" aria-live="polite">
          <span>{audio.queueProgress.label}</span>
          <div><i style={{ width: `${(audio.queueProgress.current / audio.queueProgress.total) * 100}%` }} /></div>
          <strong>{audio.queueProgress.current}/{audio.queueProgress.total}</strong>
        </div>
      )}
      {audio.error && <p className="inline-error" role="alert">{audio.error}</p>}
    </div>
  );
}
